export default __webpack_public_path__ + "static/media/742.8ad5ff0d.png";